import React, { useEffect } from "react";

import { Box, CircularProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router";

import { SignInForm } from "src/domains/auth/components/SignInForm";
import { useLegacyAuth } from "src/domains/auth/module/components/AuthProvider";
import { ORGANIZATIONS } from "src/platform/constants/routes";

import { Layout } from "./Layout";

const Login: React.FC = () => {
  const { token, loading } = useLegacyAuth();
  const navigate = useNavigate();

  // Always redirect to org selection after login.
  // The two-step auth model requires org selection on every login to obtain a
  // step-2 org-scoped token — restoring a previous org path is not safe here
  // because the user only has a step-1 token until they pick an org.
  useEffect(() => {
    if (token && !loading) {
      void navigate(ORGANIZATIONS.LIST.path, { replace: true });
    }
  }, [token, loading, navigate]);

  if (loading || token) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ mt: 2 }}>
          {loading ? "Checking authentication..." : "Redirecting..."}
        </Typography>
      </Box>
    );
  }

  return <Layout Component={SignInForm} />;
};

export default Login;
